// Preset laser-cut infill patterns — inline SVG patterns tileable across the clear panel area.
// Each preset returns an SVG <defs><pattern>…</pattern></defs> markup plus a fill reference.
// Custom uploaded designs override these with an <image href="{url}"/> pattern.

export const LASER_CUT_PRESETS = [
  {
    value: "botanical_leaf",
    label: "Botanical — Native leaf",
    category: "Nature",
    tile_mm: 200,
    render: (colour) => `
      <path d="M50 10 Q80 30 90 50 Q80 70 50 90 Q20 70 10 50 Q20 30 50 10 Z"
        fill="none" stroke="${colour}" stroke-width="2.5" />
      <path d="M50 10 L50 90 M20 30 L80 70 M20 70 L80 30" stroke="${colour}" stroke-width="1.2" />
      <circle cx="50" cy="50" r="6" fill="${colour}" />
    `,
  },
  {
    value: "geometric_hex",
    label: "Geometric — Hexagon lattice",
    category: "Geometric",
    tile_mm: 120,
    render: (colour) => `
      <polygon points="50,5 90,27 90,73 50,95 10,73 10,27" fill="none" stroke="${colour}" stroke-width="3" />
      <polygon points="50,25 75,37 75,63 50,75 25,63 25,37" fill="none" stroke="${colour}" stroke-width="2" />
    `,
  },
  {
    value: "wave",
    label: "Wave — Ocean flow",
    category: "Organic",
    tile_mm: 250,
    render: (colour) => `
      <path d="M0 50 Q25 20 50 50 T100 50" fill="none" stroke="${colour}" stroke-width="3" />
      <path d="M0 70 Q25 40 50 70 T100 70" fill="none" stroke="${colour}" stroke-width="2" />
      <path d="M0 30 Q25 0 50 30 T100 30" fill="none" stroke="${colour}" stroke-width="2" />
    `,
  },
  {
    value: "reeds",
    label: "Reeds — Vertical grass",
    category: "Nature",
    tile_mm: 80,
    render: (colour) => `
      <line x1="20" y1="5" x2="18" y2="95" stroke="${colour}" stroke-width="2.5" />
      <line x1="50" y1="0" x2="52" y2="95" stroke="${colour}" stroke-width="3" />
      <line x1="80" y1="8" x2="78" y2="95" stroke="${colour}" stroke-width="2" />
      <ellipse cx="18" cy="10" rx="2" ry="6" fill="${colour}" />
      <ellipse cx="52" cy="4" rx="2.5" ry="7" fill="${colour}" />
      <ellipse cx="78" cy="13" rx="2" ry="5" fill="${colour}" />
    `,
  },
  {
    value: "diamond_mesh",
    label: "Diamond mesh — Fine",
    category: "Geometric",
    tile_mm: 90,
    render: (colour) => `
      <path d="M50 5 L95 50 L50 95 L5 50 Z" fill="none" stroke="${colour}" stroke-width="2.5" />
      <line x1="5" y1="50" x2="95" y2="50" stroke="${colour}" stroke-width="1" />
      <line x1="50" y1="5" x2="50" y2="95" stroke="${colour}" stroke-width="1" />
    `,
  },
  {
    value: "circles",
    label: "Circles — Modern dots",
    category: "Geometric",
    tile_mm: 100,
    render: (colour) => `
      <circle cx="50" cy="50" r="30" fill="none" stroke="${colour}" stroke-width="3" />
      <circle cx="50" cy="50" r="15" fill="${colour}" />
      <circle cx="15" cy="15" r="8" fill="none" stroke="${colour}" stroke-width="2" />
      <circle cx="85" cy="85" r="8" fill="none" stroke="${colour}" stroke-width="2" />
      <circle cx="85" cy="15" r="8" fill="none" stroke="${colour}" stroke-width="2" />
      <circle cx="15" cy="85" r="8" fill="none" stroke="${colour}" stroke-width="2" />
    `,
  },
  {
    value: "mountain",
    label: "Mountain — Ranges",
    category: "Nature",
    tile_mm: 300,
    render: (colour) => `
      <path d="M0 90 L15 60 L25 75 L45 30 L60 55 L75 40 L90 65 L100 55 L100 90 Z" fill="${colour}" opacity="0.35" />
      <path d="M0 90 L15 60 L25 75 L45 30 L60 55 L75 40 L90 65 L100 55" fill="none" stroke="${colour}" stroke-width="2" />
    `,
  },
  {
    value: "starburst",
    label: "Starburst — Compass",
    category: "Geometric",
    tile_mm: 150,
    render: (colour) => `
      <g stroke="${colour}" stroke-width="2" fill="none">
        <line x1="50" y1="5" x2="50" y2="95" />
        <line x1="5" y1="50" x2="95" y2="50" />
        <line x1="20" y1="20" x2="80" y2="80" />
        <line x1="80" y1="20" x2="20" y2="80" />
        <circle cx="50" cy="50" r="35" />
      </g>
      <polygon points="50,20 55,50 50,80 45,50" fill="${colour}" />
      <polygon points="20,50 50,45 80,50 50,55" fill="${colour}" />
    `,
  },
  {
    value: "bamboo",
    label: "Bamboo — Asian screen",
    category: "Nature",
    tile_mm: 100,
    render: (colour) => `
      <rect x="20" y="0" width="6" height="100" fill="${colour}" />
      <rect x="45" y="0" width="6" height="100" fill="${colour}" />
      <rect x="70" y="0" width="6" height="100" fill="${colour}" />
      <line x1="16" y1="30" x2="30" y2="30" stroke="${colour}" stroke-width="2.5" />
      <line x1="41" y1="55" x2="55" y2="55" stroke="${colour}" stroke-width="2.5" />
      <line x1="66" y1="80" x2="80" y2="80" stroke="${colour}" stroke-width="2.5" />
      <line x1="16" y1="75" x2="30" y2="75" stroke="${colour}" stroke-width="2.5" />
    `,
  },
  {
    value: "chevron",
    label: "Chevron — Bold zigzag",
    category: "Geometric",
    tile_mm: 180,
    render: (colour) => `
      <path d="M0 20 L50 60 L100 20 M0 55 L50 95 L100 55" fill="none" stroke="${colour}" stroke-width="4" />
    `,
  },
  {
    value: "eucalyptus",
    label: "Eucalyptus — Aussie native",
    category: "Nature",
    tile_mm: 220,
    render: (colour) => `
      <path d="M50 5 L50 95" stroke="${colour}" stroke-width="2" />
      <ellipse cx="30" cy="20" rx="8" ry="16" fill="${colour}" opacity="0.85" transform="rotate(-30 30 20)" />
      <ellipse cx="70" cy="30" rx="8" ry="16" fill="${colour}" opacity="0.85" transform="rotate(30 70 30)" />
      <ellipse cx="30" cy="50" rx="8" ry="16" fill="${colour}" opacity="0.85" transform="rotate(-30 30 50)" />
      <ellipse cx="70" cy="60" rx="8" ry="16" fill="${colour}" opacity="0.85" transform="rotate(30 70 60)" />
      <ellipse cx="30" cy="80" rx="8" ry="16" fill="${colour}" opacity="0.85" transform="rotate(-30 30 80)" />
    `,
  },
  {
    value: "custom",
    label: "Custom — Upload PNG/SVG",
    category: "Custom",
    tile_mm: 500,
    render: () => "", // renders uploaded image via <image>
  },
];

export const LASER_CUT_CATEGORIES = ["Nature", "Geometric", "Organic", "Custom"];

export function getLaserPreset(value) {
  return LASER_CUT_PRESETS.find((p) => p.value === value) || LASER_CUT_PRESETS[0];
}
